import { all, call, put, select, takeLatest } from 'redux-saga/effects'
import HouseholdActions from './duck'
import HouseholdSelectors from './selectors'
import { Household } from './types'
import * as managers from './managers'
import { ListResponse } from 'types/api'
import { RequestError } from 'modules/errors'
import { push } from 'connected-react-router'
import { generatePath } from 'react-router-dom'
import HouseholdsRoutes from 'views/pages/Household/routes'

export const fetchList = function* () {
  try {
    let currentPage = yield select(HouseholdSelectors.page)
    const filter = yield select(HouseholdSelectors.filter)
    const sorting = yield select(HouseholdSelectors.sorting)
    const pageSize = yield select(HouseholdSelectors.pageSize)

    let response: ListResponse<Household> = yield call(managers.getList, filter, sorting, currentPage, pageSize)
    const pages = Math.ceil(response.total_count / pageSize)

    if (pages !== 0 && pages < currentPage) {
      response = yield call(managers.getList, filter, sorting, pages, pageSize)
      currentPage = pages
    }

    const { data, page, total_count } = response
    yield put(HouseholdActions.listRequestSucceed(data, total_count, page))

    // yield call(updateLocationQuery, HouseholdRoutes.List, { page: currentPage })
  } catch (err) {
    const { type, detail } = RequestError.parseError(err)
    yield put(HouseholdActions.listRequestFailed(type, detail))
  }
}

export const fetchListNext = function* () {
  try {
    const page = yield select(HouseholdSelectors.page)
    const filter = yield select(HouseholdSelectors.filter)
    const sorting = yield select(HouseholdSelectors.sorting)
    const pageSize = yield select(HouseholdSelectors.pageSize)
    const { data, total_count }: { data: Household[]; total_count: number } = yield call(
      managers.getList,
      filter,
      sorting,
      page,
      pageSize,
    )
    yield put(HouseholdActions.listRequestNextSucceed(data, total_count))
  } catch (err) {
    const { type, detail } = RequestError.parseError(err)
    yield put(HouseholdActions.listRequestNextFailed(type, detail))
  }
}

export const fetchItem = function* ({ payload: id }: ReturnType<typeof HouseholdActions.itemRequested>) {
  try {
    const item: Household = yield call(managers.getItem, id)
    yield put(HouseholdActions.itemRequestSucceed(item))
  } catch (err) {
    const { type, detail } = RequestError.parseError(err)
    yield put(HouseholdActions.itemRequestFailed(id, type, detail))
  }
}

export const addItem = function* ({ payload: dto }: ReturnType<typeof HouseholdActions.addRequested>) {
  try {
    const item: Household = yield call(managers.addItem, dto)
    yield put(HouseholdActions.addSucceed(item))
    yield put(push(generatePath(HouseholdsRoutes.Edit, { id: item.id })))
  } catch (err) {
    const { type, detail, errors } = RequestError.parseError(err)
    yield put(HouseholdActions.addFailed(type, detail, errors))
  }
}
export const updateItem = function* ({ payload: [id, dto] }: ReturnType<typeof HouseholdActions.updateRequested>) {
  try {
    const item: Household = yield call(managers.updateItem, id, dto)
    yield put(HouseholdActions.updateSucceed(item))
  } catch (err) {
    const { type, detail, errors } = RequestError.parseError(err)
    yield put(HouseholdActions.updateFailed(id, type, detail, errors))
  }
}

export const removeItem = function* ({ payload }: ReturnType<typeof HouseholdActions.removeRequested>) {
  try {
    yield call(managers.removeItem, payload)
    yield put(HouseholdActions.removeSucceed(payload))
    yield put(push(HouseholdsRoutes.List))
  } catch (err) {
    const { type, detail } = RequestError.parseError(err)
    yield put(HouseholdActions.removeFailed(payload, type, detail))
  }
}

const HouseholdSaga = function* () {
  yield all([
    takeLatest(HouseholdActions.itemRequested.type, fetchItem),
    takeLatest(HouseholdActions.listRequested.type, fetchList),
    takeLatest(HouseholdActions.filterUpdated.type, fetchList),
    takeLatest(HouseholdActions.sortingUpdated.type, fetchList),
    takeLatest(HouseholdActions.filterHasBeenReset.type, fetchList),
    takeLatest(HouseholdActions.sortingHasBeenReset.type, fetchList),

    takeLatest(HouseholdActions.listRequestedNext.type, fetchListNext),

    takeLatest(HouseholdActions.addRequested.type, addItem),
    takeLatest(HouseholdActions.updateRequested.type, updateItem),
    takeLatest(HouseholdActions.removeRequested.type, removeItem),
  ])
}

export default HouseholdSaga
